var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React, { Component } from 'react';
import { AwesomeComponent, ComponentType } from '@philips-internal/oswald-ui-core';
import { Button, Card } from '@philips-internal/oswald-ui-components/lib/components';
import { ButtonTheme, Placement, SelectionType } from '@philips-internal/oswald-ui-constants';
import { MessageService } from '@philips-internal/oswald-ui-core/lib/services';
import { eventListener, number, string } from '@philips-internal/oswald-ui-core/lib/component/prop-types';
import { ReactComponent as PatientClockIcon } from '../../assets/images/global/DLS_Patients_24.svg';
import { ReactComponent as ClockIcon } from '../../assets/images/icons/Clock.svg';
import moment from 'moment';
import './card-waiting-list.css';
import CardWaitingListAPI from './card-waiting-list-api';
import { generateUUID, isFunction } from '@philips-internal/oswald-ui-utils';
import ArrowIcon from '../../assets/images/icons/date-arrow-right.svg';
import { ClickEvent } from '@philips-internal/oswald-ui-core/lib/component/types';
let CardWaitingList = class CardWaitingList extends Component {
    constructor() {
        super(...arguments);
        this.handleClick = () => {
            const { joinedQueue, onClick, selectedTitle, sequencePACard, title } = this.props;
            if (isFunction(onClick)) {
                onClick(new ClickEvent({
                    value: { joinedQueue, selectedTitle, sequencePACard, title }
                }));
            }
        };
    }
    static { this.propTypes = {
        className: string,
        onClick: eventListener,
        patientsOnQueue: number,
        selectedTitle: string,
        sequencePACard: number,
        title: string,
        waitingMinutesTotal: number,
    }; }
    renderWaitingTime(minutes) {
        if (!minutes)
            return '00:00';
        const formatedTime = moment.utc().startOf('day').add(minutes, 'minutes').format('HH:mm');
        return formatedTime;
    }
    renderJoinOrCancel(joinedQueue) {
        const { selectedTitle } = this.props;
        if (joinedQueue) {
            return (React.createElement("div", { className: 'bottom-content' },
                React.createElement("div", { className: 'text-botton' },
                    MessageService.translate('patient.joined.queue'),
                    " ",
                    selectedTitle),
                React.createElement("div", { className: 'button-container' },
                    React.createElement(Button, { value: MessageService.translate('patient.cancel'), theme: ButtonTheme.ACCENT, iconPlacement: Placement.LEFT, onClick: this.handleClick, className: 'button-cancel' }))));
        }
        return (React.createElement("div", { className: 'bottom-content' },
            React.createElement("div", { className: 'text-botton' }, MessageService.translate('patient.like.to.join.queue')),
            React.createElement(Button, { value: MessageService.translate('patient.on.my.way'), theme: ButtonTheme.QUIET_EMPHASIS, icon: ArrowIcon, iconPlacement: Placement.LEFT, onClick: this.handleClick, className: 'button-going' })));
    }
    render() {
        const { className, joinedQueue, patientsOnQueue, title, waitingMinutesTotal } = this.props;
        return (React.createElement(Card, { className: `card-waiting-list ${className}`, selectionType: SelectionType.SINGLE, uuid: generateUUID() },
            React.createElement("div", { className: 'all-content' },
                React.createElement("div", { className: 'upper-content' },
                    React.createElement("div", { className: 'text-title' }, title),
                    React.createElement("div", { className: 'panel-time' },
                        React.createElement("div", { className: 'text-waiting-time' }, this.renderWaitingTime(waitingMinutesTotal)),
                        React.createElement("div", { className: 'text-waiting-time' }, patientsOnQueue)),
                    React.createElement("div", { className: 'panel-text' },
                        React.createElement("div", { className: 'waiting-time' },
                            React.createElement("div", null,
                                React.createElement(ClockIcon, { className: 'clock-icon' })),
                            React.createElement("div", { className: 'text-waiting' }, MessageService.translate('patient.waiting.approximate.time'))),
                        React.createElement("div", { className: 'patient' },
                            React.createElement("div", null,
                                React.createElement(PatientClockIcon, { className: 'patient-icon' })),
                            React.createElement("div", { className: 'text-patient' },
                                " ",
                                MessageService.translate('patient.patients'),
                                " ")))),
                this.renderJoinOrCancel(joinedQueue))));
    }
};
CardWaitingList = __decorate([
    AwesomeComponent({ api: CardWaitingListAPI, type: ComponentType.DATA_DISPLAY })
], CardWaitingList);
export default CardWaitingList;
//# sourceMappingURL=card-waiting-list.js.map